module.exports = __webpack_public_path__ + "assets/desktop_card_view.31f28ff2.svg";